import { TableNodeProperties } from "@features/builder/graph/types"
import { BaseGraphTableNode } from "@store/services/converter/types"
import { csvContentToRows } from "@utils/file"

const SEPARATOR = ","

export const tablePropertiesToCsv = ({ columns, data, index }: BaseGraphTableNode): string => {
  let csv = `data:text/csv;charset=utf-8,${SEPARATOR}${columns.join(SEPARATOR)}\n`
  index.forEach((c, i) => {
    if (!data[i] || !index[i]) return
    csv += `${index[i]}${SEPARATOR}${data[i].join(SEPARATOR)}\n`
  })
  return csv
}

export const tableCsvToProperties = (csv: string): TableNodeProperties | undefined => {
  const rows = csvContentToRows(csv)
  const firstRow = rows[0]
  if (!firstRow) return

  const columns = firstRow.split(SEPARATOR).slice(1)
  const index: string[] = []
  const data: string[][] = []

  rows.forEach((row, i) => {
    if (i === 0) return
    const arr = row.split(SEPARATOR)
    if (!arr[0]) return
    index.push(arr[0])
    data.push(arr.slice(1))
  })
  if (index[index.length - 1] === "") {
    index.pop()
    data.pop()
  }

  return { index, columns, data }
}
